export const getRegionByCode = (regions, topRegion) => {
  if (topRegion && regions?.length) {
    const countryCode = topRegion.country_code
    const provinceCode = topRegion.province_code
    const country = regions.find(r => r.code === countryCode)

    let province = null

    if (provinceCode) {
      province = country.provinces.find(p => p.code === provinceCode)
    }

    return { country, province }
  }
}
